export default "/assets/images/mila-feed-14-thumbnail.2888d681b9c82c1b.jpg";